import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Toggle from 'react-toggle';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffRfmsReportFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: null,
      fatigue_incident: 0,
      applicabilities_list: [],
      staff_list: [],
      roles_list: [],
      aircraft_models_list: [],
      bases_list: [],
      date_start: '',
      date_finish: '',
      applicability_id: '',
      crew_visibility: {display: 'none'},
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.searchReports = this.searchReports.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleSelectChangeApplicability(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aplicabilidade/colaboradores/listagens/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            roles_list: responseJson.data.roles,
            bases_list: responseJson.data.bases,
            staff_list: responseJson.data.staffs,
            aircraft_models_list: responseJson.data.aircraft_models,
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorios-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            staff_list: responseJson.data.staff_list,
            roles_list: responseJson.data.roles_list,
            aircraft_models_list: responseJson.data.aircraft_models_list,
            bases_list: responseJson.data.bases_list,
            applicabilities_list: responseJson.data.applicabilities_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  searchReports(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      staff_ids: this.state.staff_ids,
      roles: this.state.roles_ids,
      applicability_id: this.state.applicability_id,
      aircraft_models: this.state.aircraft_models_ids,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      fatigue_incident: this.state.fatigue_incident,
      bases: this.state.bases_ids,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios-de-fadiga/buscar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  

  ActionsButtons (cell, row) {
    var url = '/parametro-de-fadiga/editar/' + cell;
    
    var botao = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var fatigue_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/parametro-de-fadiga/' + fatigue_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(fatigue_id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  filterCrew (event) {
    var self = this;
    var staff = [];
    var i = 0;
    Object.keys(self.state.data.checkboxes).map(function(k) {
      if (self.state.data.checkboxes[k].checked) {
        staff[i] = {
          value: self.state.data.checkboxes[k].staff_id,
          label: self.state.data.checkboxes[k].staff_id,
        };
        i = i+1;
      }
    });
    this.handleAlert('', '', 'open');
    var datasave = {
      staff_ids: staff,
      roles: this.state.roles_ids,
      applicability_id: this.state.applicability_id,
      aircraft_models: this.state.aircraft_models_ids,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      fatigue_incident: this.state.fatigue_incident,
      bases: this.state.bases_ids,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios-de-fadiga/buscar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  toggleCheckbox (index) {
    var self = this;
    index = parseInt(index);
    // Verifica-se se o checkbox está marcado ou desmarcado
    var data = this.state.data;
    if (this.state.data.checkboxes[index].checked) {
      data.checkboxes[index].checked = false;
    } else {
      data.checkboxes[index].checked = true;
    }
    this.setState({data: data});
  }
  
  deleteRow(fatigue_id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == fatigue_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.titulo}</h3>
      <hr/>
      <form onSubmit={this.searchReports}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} required maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeApplicability.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
                required
              />
            </div>
          </div>
          {this.state.applicability_id == 2 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Mecanicos}:</label>
                <Select
                  className="form-field-name"
                  name="staff_ids"
                  value={this.state.staff_ids}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarMecanicos}
                  onChange={this.handleSelectChange.bind(this, 'staff_ids')}
                  options={this.state.staff_list}
                  multi={true}
                />
              </div>
            </div>
            : this.state.applicability_id == 3 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Coordenadores}:</label>
                <Select
                  className="form-field-name"
                  name="staff_ids"
                  value={this.state.staff_ids}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarCoordenadores}
                  onChange={this.handleSelectChange.bind(this, 'staff_ids')}
                  options={this.state.staff_list}
                  multi={true}
                />
              </div>
            </div>
            :
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Tripulantes}:</label>
                <Select
                  className="form-field-name"
                  name="staff_ids"
                  value={this.state.staff_ids}
                  searchable={true}
                  placeholder={this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarTripulantes}
                  onChange={this.handleSelectChange.bind(this, 'staff_ids')}
                  options={this.state.staff_list}
                  multi={true}
                />
              </div>
            </div>
          }
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Cargos}:</label>
              <Select
                className=""
                name="roles_ids"
                value={this.state.roles_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarCargos}
                onChange={this.handleSelectChange.bind(this, 'roles_ids')}
                options={this.state.roles_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Frotas}:</label>
              <Select
                className=""
                name="aircraft_models_ids"
                value={this.state.aircraft_models_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarFrotas}
                onChange={this.handleSelectChange.bind(this, 'aircraft_models_ids')}
                options={this.state.aircraft_models_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Bases}:</label>
              <Select
                className=""
                name="bases_ids"
                value={this.state.bases_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarBases}
                onChange={this.handleSelectChange.bind(this, 'bases_ids')}
                options={this.state.bases_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.ApenasIncidentesDeFadiga}?</label>
              <br/>
              <Toggle
                checked={this.state.fatigue_incident}
                aria-label='No label tag'
                name="fatigue_incident"
                onChange={this.handleToggleChange.bind(this, 'fatigue_incident')} />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.botaoProcurarRelatorios}</button>
        </div>
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.tituloListaDeRelatoriosDeFadiga}</h3>
      <hr/>
      {self.state.data !== null ? 
          <div>
            <div>
              <LineChart width={890} height={400} data={self.state.data.dates}
                    margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                <XAxis dataKey="name"/>
                <YAxis/>
                <CartesianGrid strokeDasharray="3 3"/>
                <Tooltip/>
                <Legend />
                {Object.keys(self.state.data.names).map(function(k) {
                  return (
                   <Line type="monotone" dataKey={self.state.data.names[k].name} stroke={self.state.data.names[k].color} activeDot={{r: 8}}/>
                  );
                })}
              </LineChart>
            </div>
            <button className="btn btn-block btn-lg btn-success"  onClick={() => {
              if (self.state.crew_visibility.display === 'none') {
                self.setState({crew_visibility: {display: 'block'}});
              } else {
                self.setState({crew_visibility: {display: 'none'}});
              }
            }}><i className="fa fa-fw fa-users"></i> {this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.botaoMostrarEsconderTripulantes}</button>
            <div style={this.state.crew_visibility}>
              <hr/>
              <button className="btn btn-block btn-info"  onClick={() => {self.filterCrew();}}><i className="fa fa-fw fa-users"></i> {this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.botaoFiltrarTripulantes}</button>
              <hr/>
              <table className="table table-bordered table-stripped table-hover">
                <thead>
                  <tr>
                    <th className="col-md-1 text-center"></th>
                    <th className="text-center">{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.tabela.Nome}</th>
                    <th className="text-center">{this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.tabela.Pontos}</th>
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.data.names_list).map(function(k) {
                    return (
                      <tr>
                        <td className="text-center">
                          <input
                          name="payment_checked"
                          type="checkbox"
                          checked={self.state.data.checkboxes[k].checked}
                          className="checkbox-filter-search"
                          onChange={() => { self.toggleCheckbox(k); }} />
                        </td>
                        <td className="text-center">{self.state.data.names_list[k].nickname}</td>
                        <td className="text-center">{self.state.data.names_list[k].points}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <button className="btn btn-block btn-info"  onClick={() => {self.filterCrew();}}><i className="fa fa-fw fa-users"></i> Filtrar tripulantes</button>
            </div>
          </div>
      : ""}
    </div>
  </div>
</div>
    );
  }
}

export default StaffRfmsReportFilter;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportFilter.js